<!-- 加工技术 -->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <img src="./../../assets/zzjs_01.png"/>
  </div>
  <div class="site-content-page width-per-100">
    <div class="content-row">
      <div class="content-col">
        <searchPageList-01 title="加工技术" label="LAST NEWS" count="8"  :infoBlock="infoBlock"  :infoPage="infoPage" :tabList="tabList" :tabDefaultType="tabDefaultType" v-on:queryPage="jgjs_Req"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoList01 from '../block/InfoList01'
import ImgLink03 from '../block/ImgLink03'
import SearchPageList01 from '../block/SearchPageList01'
import InfoBlock05 from '../block/InfoBlock05'
export default {
  name: 'Jrfw05',
  components: {
    'searchPageList-01': SearchPageList01,
    'imgLink-03':ImgLink03,
  },
  data() {
    return {
      tabList_test:[{title:"种植技术",type:'1'},{title:"防病虫害",type:'2'},{title:"防病虫害",type:'3'},{title:"采摘标准",type:'4'}],
      tabList:[],
      tabDefaultType:'processing_technology',
      infoBlock:InfoBlock05,
      infoPage:{},
    }
  },
  methods:{
    //加工技术
    jgjs_Req(params){
          let that=this;
          let result={page:params};
          params.p=params.page;
          params.keyword=params.keyWord;
          params.category=that.tabDefaultType;
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.mediaLists(params).then(res =>{
            //console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            result.list= res.data.list;
            result.page.total=res.data.count;
            that.infoPage=result;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Jrfw05.vue